(() => {
  const duration = 97 * 60 * 1000;
  // Keep the existing QL PDP deadline across both steps of the funnel.
  const key = 'inira:pdp-libido-launch:v3:/pages/ql-pdp-01';
  const now = Date.now();
  let deadline = now + duration;
  try {
    const saved = Number(localStorage.getItem(key));
    if (Number.isFinite(saved) && saved > now && saved <= deadline) deadline = saved;
    else localStorage.setItem(key, String(deadline));
  } catch (_) {}

  const init = () => {
    document.querySelectorAll('[data-libido-offer-countdown]').forEach(bar => {
      if (bar.dataset.countdownReady) return;
      bar.dataset.countdownReady = 'true';
      let interval;
      const tick = () => {
        if (!bar.isConnected) { clearInterval(interval); return; }
        const left = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        const parts = [Math.floor(left / 3600), Math.floor(left % 3600 / 60), left % 60].map(n => String(n).padStart(2, '0'));
        const compact = bar.querySelector('[data-countdown-text]');
        if (compact) compact.textContent = parts.join(':');
        else ['hours', 'minutes', 'seconds'].forEach((name, i) => {
          bar.querySelector(`[data-${name}]`).textContent = parts[i];
        });
        if (!left) { bar.style.display = 'none'; clearInterval(interval); }
      };
      interval = setInterval(tick, 1000);
      tick();
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
